<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2 class="text-white">Subcarrier</h2>
  </div>

  <sa-subnav class="subnav" [subnavMenu]="subnavMenu" (onTabSwitch)="activeMenu = $event"></sa-subnav>

  <div class="content" *ngIf="activeMenu === subnavLabels.contracts">
    <div class="contracts">
      <sa-subcarrier-vendor-contracts></sa-subcarrier-vendor-contracts>
    </div>
  </div>

  <ng-container *saFeatureFlag="'lmoBanDrivers'">
    <div class="content" *ngIf="activeMenu === subnavLabels.drivers">
      <div class="drivers">
        <sa-lmo-driver-list></sa-lmo-driver-list>
      </div>
    </div>
  </ng-container>

  <ng-container *saFeatureFlag="'lmoBanDrivers'">
    <div class="content" *ngIf="activeMenu === subnavLabels.suspendedDrivers">
      <div class="drivers">
        <sa-lmo-banned-driver-list></sa-lmo-banned-driver-list>
      </div>
    </div>
  </ng-container>

  <ng-container *saFeatureFlag="'allowDriverSiteRestriction'">
    <div class="content" *ngIf="activeMenu === subnavLabels.driverSiteRestrictions">
      <div class="drivers">
        <sa-lmo-driver-site-restrictions-list></sa-lmo-driver-site-restrictions-list>
      </div>
    </div>
  </ng-container>
</div>
